import { useMemo } from 'react';
import { getAppDefaultPaths } from '@/router/utils';
import { ProvideDefaultPathsContext, type ProvideDefaultPathsValue } from './context';

export function ProvideDefaultPaths(props: ChildrenProps) {
  const defaultPaths = getAppDefaultPaths();
  const value = useMemo<ProvideDefaultPathsValue>(() => ({
    loginPath: defaultPaths.login,
    homePath: defaultPaths.home,
  }), [defaultPaths]);

  return (
    <ProvideDefaultPathsContext.Provider value={value}>
      {props.children}
    </ProvideDefaultPathsContext.Provider>
  );
}